import { type fabric } from 'fabric';
import ControlBase from '../fabric/ControlBase';
import { renderAddControl } from './controlRendering';
import ToolLayoutAddObject from '../tools/ToolLayoutAddObject';

const SIZE = 22;

class AddObjectControl extends ControlBase {
  actionName = 'Add object';
  cursorStyle = 'pointer';
  y = 0.5;
  offsetY = 20;

  getMouseUpHandler(): fabric.ControlMouseEventHandler {
    return (eventData, transformData) => {
      const object = transformData.target;
      if (object) {
        ToolLayoutAddObject.action({
          selection: object,
          controller: object.controller,
        });
      }
      return true;
    };
  }

  updatePosition(orientation: 'horizontal' | 'vertical') {
    if (orientation === 'horizontal') {
      this.x = 0.5;
      this.y = 0;
      this.offsetX = 20;
      this.offsetY = 0;
    } else {
      this.x = 0;
      this.y = 0.5;
      this.offsetX = 0;
      this.offsetY = 20;
    }
  }

  render(ctx, left, top, styleOverride, fabricObject) {
    renderAddControl.call(
      this,
      ctx,
      left,
      top,
      styleOverride,
      fabricObject,
      SIZE
    );
  }
}
export default AddObjectControl;
